import { BannerStripComplete } from '@/molecules';

/**
 * BannerStrip
 */
const BannerStrip = ({ bloque, id }: any) => (
  <BannerStripComplete
    id={id}
    top={
      bloque.papelRasgado.zona === 'top' ||
      bloque.papelRasgado.zona === 'top bottom'
        ? true
        : false
    }
    bottom={
      bloque.papelRasgado.zona === 'bottom' ||
      bloque.papelRasgado.zona === 'top bottom'
        ? true
        : false
    }
    border={bloque.papelRasgado.border}
    borderHeight={bloque.papelRasgado.borderHeight}
    borderColor={bloque.papelRasgado.borderColor}
    bgColor={bloque.backgroundColorString}
    textColor={bloque.textColorString}
    image={{
      src: bloque.image.sourceUrl,
      width: bloque.image.mediaDetails.width,
      height: bloque.image.mediaDetails.height,
      alt: bloque.image.altText,
    }}
    button={{
      href: bloque?.link?.url,
      label: bloque.label,
      style: bloque.style,
      negative: bloque.negative,
    }}
  >
    {bloque.text}
  </BannerStripComplete>
);

BannerStrip.displayName = 'BannerStrip';

export default BannerStrip;
